<template>
  <div>
    <div class="Box">
      <div class="background1"></div>
      <div class="background2"></div>
      <div v-if="state.advertList.length" class="FileList limitBox" style="padding: 20px 0 0 0;display: flex;align-items: center;">
        <div style="width: 100%;cursor: auto">
          <el-image
            :src="state.advertList[0].img"
            fit="cover"
            class="cuImage"
            @click="ExternalLinks(state.advertList[0])"
            style="width: 100%; height: 120px; display: block"
          >
            <template #error>
              <div class="image-slot">
                <span>加载中</span>
              </div>
            </template>
          </el-image>
        </div>
        <div v-if="state.advertList.length > 1" style="width: 30px;"></div>
        <div v-if="state.advertList.length > 1" style="width: 100%;cursor: auto">
          <el-image
            :src="state.advertList[1].img"
            fit="cover"
            class="cuImage"
            @click="ExternalLinks(state.advertList[1])"
            style="width: 100%; height: 120px; display: block"
          >
            <template #error>
              <div class="image-slot">
                <span>加载中</span>
              </div>
            </template>
          </el-image>
        </div>
        <div v-if="state.advertList.length > 2" style="width: 30px;"></div>
        <div v-if="state.advertList.length > 2" style="width: 100%;cursor: auto">
          <el-image
            :src="state.advertList[2].img"
            fit="cover"
            class="cuImage"
            @click="ExternalLinks(state.advertList[2])"
            style="width: 100%; height: 120px; display: block"
          >
            <template #error>
              <div class="image-slot">
                <span>加载中</span>
              </div>
            </template>
          </el-image>
        </div>
      </div>
      <div class="FileList limitBox">
        <div style="width: calc(40% - 30px);">
          <NewsComp :NewsCompConfig="state.NewsCompConfig1" :pageN="7"></NewsComp>
        </div>
        <div style="width: calc(40% - 30px);">
          <NewsComp :NewsCompConfig="state.NewsCompConfig2" :pageN="7"></NewsComp>
        </div>
        <div style="width: calc(20% - 30px);">
          <div class="NewsList">
            <div class="DisplayFlex">
              <div class="mainTitle">
                <p>标准查询</p>
                <p>Standard</p>
              </div>
            </div>
            <div>
              <div class="SearchBox" style="height: 40px;margin-top: 30px;" @click="handleStandard()">
                <div style="height: 40px;">
                  <span class="iconfont iconsousuo" style="line-height: 40px;font-size: 18px;margin-left: 10px;margin-right: 10px;"></span>
                  <input
                    placeholder=""
                    type="search"
                    v-model="state.title"
                    style="font-size: 14px;"
                  />
                </div>
                <div style="height: 40px;">
                  <span style="height: 40px;line-height: 40px;width: 70px;font-size: 14px;">查询</span>
                </div>
              </div>
            </div>
            <div @click="handleStandard(7)" style="cursor: pointer;margin-top: 30px;border: 2px solid #008fd7;border-radius: 10px;color: #008fd7;height: 60px;display: flex;align-items: center;justify-content: center;font-size: 18px;font-weight: 400;">
              协会团体标准查询
            </div>
            <div @click="handleStandard(8)" style="cursor: pointer;margin-top: 35px;border: 2px solid #008fd7;border-radius: 10px;color: #008fd7;height: 80px;display: flex;flex-direction: column;align-items: center;justify-content: center;font-size: 18px;font-weight: 400;">
              <div>广西工程建设</div>
              <div>地方标准查询</div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="state.advertList1.length" class="FileList limitBox" style="padding-top: 0;display: flex;align-items: center;">
        <div style="width: 100%;cursor: auto">
          <el-image
            :src="state.advertList1[0].img"
            fit="cover"
            class="cuImage"
            @click="ExternalLinks(state.advertList1[0])"
            style="width: 100%; height: 120px; display: block"
          >
            <template #error>
              <div class="image-slot">
                <span>加载中</span>
              </div>
            </template>
          </el-image>
        </div>
        <div v-if="state.advertList1.length > 1" style="width: 30px;"></div>
        <div v-if="state.advertList1.length > 1" style="width: 100%;cursor: auto">
          <el-image
            :src="state.advertList1[1].img"
            fit="cover"
            class="cuImage"
            @click="ExternalLinks(state.advertList1[1])"
            style="width: 100%; height: 120px; display: block"
          >
            <template #error>
              <div class="image-slot">
                <span>加载中</span>
              </div>
            </template>
          </el-image>
        </div>
        <div v-if="state.advertList1.length > 2" style="width: 30px;"></div>
        <div v-if="state.advertList1.length > 2" style="width: 100%;cursor: auto">
          <el-image
            :src="state.advertList1[2].img"
            fit="cover"
            class="cuImage"
            @click="ExternalLinks(state.advertList1[2])"
            style="width: 100%; height: 120px; display: block"
          >
            <template #error>
              <div class="image-slot">
                <span>加载中</span>
              </div>
            </template>
          </el-image>
        </div>
      </div>
      <div class="FileList limitBox" style="padding-top: 0;">
        <div style="width: calc(50% - 30px);">
          <NewsComp :NewsCompConfig="state.NewsCompConfig3" :pageN="7"></NewsComp>
        </div>
        <div style="width: calc(50% - 30px);">
          <NewsComp :NewsCompConfig="state.NewsCompConfig4" :pageN="7"></NewsComp>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as Vue from "vue";
import router from "@/router";
import NewsComp from "../Components/NewsComp";
import { Vue3SeamlessScroll } from "vue3-seamless-scroll";
import api from "@/comment/request/api";
export default {
  name: "NewsList",
  components: { NewsComp, Vue3SeamlessScroll },
  setup(props, { attrs, slots, emit }) {
    const state = Vue.reactive({
      NewsCompConfig1: {
        url: '/info/news/index',
        title: "协会新闻",
        eTitle: "Association",
        path: '/News',
        detail: 'NewsDetails',
        id: 'news_id',
        cate_id: 1,
      },
      NewsCompConfig2: {
        url: '/info/news/index',
        title: "BIM联盟新闻",
        eTitle: "BIM Alliance",
        path: '/News',
        detail: 'NewsDetails',
        id: 'news_id',
        cate_id: 2,
      },
      NewsCompConfig3: {
        url: '/info/news/index',
        title: "标准动态",
        eTitle: "Standard",
        path: '/News',
        detail: 'NewsDetails',
        id: 'news_id',
        cate_id: 3,
      },
      NewsCompConfig4: {
        url: '/info/news/index',
        title: "行业动态",
        eTitle: "Industry",
        path: '/News',
        detail: 'NewsDetails',
        id: 'news_id',
        cate_id: 4,
      },
      advertList: [],
      advertList1: [],
    });
    /*获取友情链接列表 */
    const GetDataList = () => {
      api.GetConfigs('home_adverts,home_adverts1').success((res) => {
        if(res.data.data.home_adverts){
          state.advertList = JSON.parse(res.data.data.home_adverts)
        }
        if(res.data.data.home_adverts1){
          state.advertList1 = JSON.parse(res.data.data.home_adverts1)
        }
      })
    }
    GetDataList();
    const handleStandard = (cate_id) => {
      router.push({
        path: '/Standard',
        query: { c: cate_id },
      })
    };
    const ExternalLinks = (item) => {
      if (item.type == 1) {
        window.open(item.url, "_black");
      }
      if (item.type == 0) {
        router.push({ path: item.url, query: item.query || {} });
      }
    };
    return {
      state,
      handleStandard,
      ExternalLinks,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "/src/comment/comment";

.tabData {
  width: auto;
  height: 168px;
  white-space: nowrap;
  overflow: hidden;
}

.Box {
  position: relative;
  overflow: hidden;
  .background1 {
    width: 250px;
    height: 450px;
    position: absolute;
    right: -10px;
    top: 50%;
    transform: translateY(-50%);
    background: url("../img/redBg1.png");
    background-size: cover;
    opacity: 0.05;
    z-index: -10;
  }
  .background2 {
    width: 392px;
    height: 550px;
    position: absolute;
    left: -70px;
    top: -40px;
    background: url("../img/redBg1.png") center right no-repeat;
    background-size: cover;
    opacity: 0.05;
    z-index: -10;
  }
}
.FileList {
  padding-top: 40px;
  padding-bottom: 40px;
  display: flex;
  justify-content: space-between;
  > div {
    width: calc(33% - 30px);
  }
}

.SpecialBox {
  margin-top: 40px;
  position: relative;

  > div:nth-child(1) {
    cursor: pointer;
  }

  > div:nth-child(2) {
    position: absolute;
    right: 0;
    bottom: 0;
    background-color: #008fd7;
    padding: 10px 20px;
    cursor: pointer;
    display: none;

    p {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
    }
  }
}

.NewsList {
  .DisplayFlex {
    border-bottom: 5px solid #d8d8d8;
    position: relative;
  }
  .mainTitle {
    width: calc(100% - 100px);
    margin-top: 12px;
    //margin-left: 30px;
    padding-bottom: 10px;
    line-height: 24px;
  }
}
</style>